import React from "react"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import UserI9Store from "../../../../stores/UserI9Store"

export default class Section2Review extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: UserI9Store.getI9(),
            user: AuthenticationStore.getLoggedInUser()
        }

        this.change = this.change.bind(this)
        this.i9ChangeEvent = this.i9ChangeEvent.bind(this)
    }

    componentDidMount() {
        AuthenticationStore.on("change", this.change)
        UserI9Store.on("change", this.i9ChangeEvent)
    }

    componentWillUnmount() {
        AuthenticationStore.removeListener("change", this.change, false)
        UserI9Store.removeListener("change", this.i9ChangeEvent, false)
    }

    change() {
        this.setState({
            user: AuthenticationStore.getLoggedInUser()
        })
    }

    i9ChangeEvent() {
        this.setState({
            i9: UserI9Store.getI9()
        })
    }

    render() {
        if (this.state.i9) {
            return (
                <div className="Section2Review">
                    <embed
                        src={UserI9Store.getI9Pdf()}
                        width="730px"
                        height="500px"
                        style={{
                            border: "solid 1px #cccccc",
                            marginBottom: 10
                        }}
                    />
                    <div>
                        <b>
                            {this.state.user.FirstName} {this.state.user.LastName}
                        </b>{" "}
                        you attest, under penalty of perjury, that (1) you have examined the document(s) presented by the above-named employee, (2) the above-listed document(s) appear to be genuine
                        and to relate to the employee named, and (3) to the best of your knowledge the employee is authorized to work in the United States.
                    </div>
                </div>
            )
        }
    }
}
